module.exports = __webpack_public_path__ + "img/ClickForSound_16.bbadf3f1.png";